import Reflux from "reflux";
import { ActionsDataViz } from "../Actions/ActionsDataViz/ActionsDataViz";
import logger from "../utils/LoggerFrontend";

export default class DataVizStore extends Reflux.Store {
  constructor() {
    super();

    this.state = {
      campaignData: [],
      channelCampaigns: [],
      adsets: [],
      metricsToUse: [],
      selectedChannel: { engagementMetrics: null, performanceMetrics: "allChannelsAverage" },
      selectedOptions: { performanceMetrics: "ctr" },
      metricHovered: null,
      interactionMetrics: null
    };

    this.listenables = ActionsDataViz;
  }

  onLoadDataVizCampaignDataCompleted(campaignData) {
    logger.log("DataVizStore:onLoadDataVizCampaignDataCompleted", "called..: ", {
      campaignId: campaignData && campaignData.id
    });

    this.setState({
      campaignData: campaignData
    });
  }

  onLoadDataVizCampaignDataFailed(error) {
    logger.log("error:DataVizStore:loadDataVizCampaignData", "Campaign Data...", {
      error
    });
  }

  onGetDataVizChannelCampaignsByCampaignIdCompleted(channelCampaigns) {
    logger.log("DataVizStore:onGetDataVizChannelCampaignsByCampaignIdCompleted", "called..: ", {
      nrOfChannelCampaigns: channelCampaigns && channelCampaigns.length
    });
    this.setState({
      channelCampaigns
    });
  }

  onGetDataVizAdsetsByCampaignIdCompleted(adsets) {
    logger.log("DataVizStore:onGetDataVizAdsetsByCampaignIdCompleted", "called..: ", {
      adsets: adsets,
      adSetLen: adsets && adsets.length
    });

    const sortedAdsets = [...adsets].sort((a, b) => {
      return b.flight - a.flight;
    });

    this.setState({
      adsets: sortedAdsets
    });
  }

  onGetDataVizAdsetsByCampaignIdFailed(error) {
    logger.log("error:DataVizStore:onGetDataVizAdsetsByCampaignIdFailed", "called..: ", {
      error
    });
    this.setState({
      adsets: []
    });
  }

  onSelectChannel(channel, cardKey) {
    const updatedSelectedChannel = {
      ...this.state.selectedChannel,
      [cardKey]: channel
    };

    this.setState({
      selectedChannel: updatedSelectedChannel
    });
  }

  onSelectOptions(option, cardKey) {
    const updatedSelectedOptions = {
      ...this.state.selectedOptions,
      [cardKey]: option
    };

    this.setState({
      selectedOptions: updatedSelectedOptions
    });
  }

  onMetricHovered(metricName) {
    this.setState({
      metricHovered: metricName
    });
  }

  onSetInteractionMetrics(metricData) {
    this.setState({
      interactionMetrics: metricData
    });
  }

  onSetMetricsToUse(channelCampaigns, selectedAdsetId) {
    const generatedMetrics = {};
    if (!channelCampaigns) return;

    channelCampaigns.forEach((channelCampaign) => {
      const platformCampaignIdChannel = `${channelCampaign.channel}__${channelCampaign.platformCampaignId}__${channelCampaign.platformAdsetId}`;

      if (!selectedAdsetId || channelCampaign.adsetId == selectedAdsetId) {
        generatedMetrics[platformCampaignIdChannel] = channelCampaign.metrics || {};
      }
    });

    this.setState({
      metricsToUse: generatedMetrics
    });
  }
}
